/**
 * Tone colours for dashboard tiles — mirrors the clinic app:
 *   primary (navy) = core record/actions, brass = services/credits,
 *   stone = support/admin.
 */
export const TONES = {
  primary: '#11223E',
  brass: '#8C6D1F',
  stone: '#7A6E5C',
};
